import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import Printd from 'printd'

export default {

	name: 'confirm-line-haul-connection',
	components: {
		Paginate,
		DatePicker,
		BasicSelect,
		VueElementLoading,
	},
	data: function() {
		return {
			isLoading: false,
			binno:"",
			invalidTokenModal: false,
			invalidtokenmsg: '',
			destinationHub:'',
			listData:[],
			displayList:false,
			listHubZoneData:[],
			listHubZoneObjDataFlt1:{
				value:'',
				text:''
			},
			hubzoneidflt1:'',
			destinationHubData:[],
			listDestinationHubs:{
				value:'',
				text:''
			},
			bin:'',
			binShipmentDetails:[],
			showBinShipmentDetils:false,
			hubName:'',
			shippingid:'',
			removeShipmentConfirmationModel: false,
			binid:'',
			UpdateStatusModal:false,
			binLoading:false,
			hubzoneLoading: '',
			hubLoading:'',
		}
	},
	created: function() {},
	computed: {},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdby = userdetail[0].email;
		this.hubId = userdetail[0].HubId[0];
		this.showHourlyHubBagCount();
		this.getHubZoneData();
		this.getHubName(this.hubId)
	},
	methods: {
		getHubZoneData() {
			var self = this
			this.hubzoneLoading = 'Loading Hub Zone...'
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubzone/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubzoneLoading = ''
					var listHubZoneData = result.data.ResponseData;
					for (i = 0; i < listHubZoneData.length; i++) {
						this.listHubZoneData.push({
							value: listHubZoneData[i].hubzoneid,
							text: listHubZoneData[i].hubzonename
						})
					}
				}, error => {
					this.hubzoneLoading = ''
					console.error(error)
				})
		},
		selectedHubZoneFlt1(hubData){
			this.listHubZoneObjDataFlt1 = hubData
			this.hubzoneidflt1 = hubData.value;
			if (this.hubzoneidflt1 != undefined) {
				this.getDestinationHubList(this.hubzoneidflt1)
			}
		},
		getDestinationHubList(data) {
			this.hubLoading = 'Loading Hub...'
			this.destinationHubData = [];
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				hubZoneId: data
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubLoading = ''
					var destinationHubData = result.data.ResponseData;
					for (i = 0; i < destinationHubData.length; i++) {
						this.destinationHubData.push({
							value: destinationHubData[i].HubID,
							text: destinationHubData[i].HubCode + ' - ' + destinationHubData[i].HubName + ' (' + destinationHubData[i].HubID + ')',
							text1: destinationHubData[i].HubName,
							hubcode: destinationHubData[i].HubCode
						})
					}
				}, error => {
					this.hubLoading = '';
					console.error(error)
				})
		},
		selectedDestination(selectedData) {
			this.listDestinationHubs = selectedData
			this.destinationHub = selectedData.value;
		},
		showHourlyHubBagCount() {
			this.isLoading = true;
			this.listData=[],
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + "getActiveBinReport?currentHubId="+ this.hubId + '&destinationHubId=' + this.destinationHub + '&binNo=' + this.binno,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
						this.displayList=true
						this.listData=result.data.ResponseData
						// this.$alertify.success(result.data.ReturnMessage)
						this.invalidTokenModal = false
          } else if (result.data.ResultCode == 401) {
						this.invalidTokenModal = true
						this.invalidtokenmsg = result.data.ReturnMessage
						this.$alertify.error(result.data.ReturnMessage)
          } else {
						this.displayList=false
						this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
					this.isLoading = false;
        }, error => {
					this.isLoading = false;
          console.error(error)
        })
    },
		logout(e) {
			localStorage.removeItem('permissiondata')
			localStorage.removeItem('userdetail')
			localStorage.removeItem('userToken')
			localStorage.removeItem('isLoggedIn')
			localStorage.removeItem('loginDate')
			this.$router.push('/login')
			e.preventDefault()
		},
		closeinvalidTokenModal() {
			this.invalidTokenModal = false
			this.invalidtokenmsg = ''
		},
		resetForm() {
			this.isLoading = false;
			this.destinationHub='',
			this.listHubZoneObjDataFlt1={
				value:'',
				text:''
			},
			this.hubzoneidflt1='',
			this.destinationHubData=[],
			this.listDestinationHubs={
				value:'',
				text:''
			}
			this.binno="";
			this.$validator.reset();
			this.errors.clear();
		},
		showBinShipmentLog(bin,binid){
			this.isLoading = true;
			this.binShipmentDetails = []; this.bin=''; this.shippingid = '';
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getBinDetailsByBinNo?binNo=' + bin + '&CurrentHubId='+this.hubId + '&binid='+binid,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.bin = bin; this.binid = binid;
						this.binShipmentDetails = result.data.ResponseData.ShipmentDetails;
						this.showBinShipmentDetils=true;
					} else {
						this.$alertify.error(result.data.ReturnMessage);
						this.binShipmentDetails = [];
					}
					this.isLoading = false;
				}, error => {
					this.isLoading = false;
					console.error(error)
				})
		},
		closeBinShipmentLog()
		{
			this.showBinShipmentDetils = false
			$(document.body).removeClass("modal-open");
			$(".modal-backdrop").remove();
		},
		getHubName(hubid) {
      this.CityId = 0
      this.input = {
        hubids: [hubid]
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.hubName = result.data.ResponseData[0].HubName;
          } else {
            this.hubName = '';
          }
        }, error => {
          console.error(error)
        })
    },
		removeBinShipment(){
			this.isLoading = true;
			this.input = ({
				binNumber: this.bin,
				shippingId: this.shippingid,
				currentHubId: this.hubId,
				lastModifiedBy: this.createdby,
				currentHubName: this.hubName,
				binid: this.binid
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'removeBinShipment',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(async result => {
 				 if (result.data.ResultCode == 100) {

 					 await this.showBinShipmentLog(this.bin,this.binid);
 					 this.$alertify.success(result.data.ReturnMessage);
 				 } else {
 					 this.$alertify.error(result.data.ReturnMessage);
 				 }
				 this.isLoading = false;
				}, error => {
					this.isLoading = false;
					console.error(error)
				})
		},
		cancelRemoveShipment() {
			this.showBinShipmentLog(this.bin);
      this.removeShipmentConfirmationModel = false
    },
    removeShipment(shippingid) {
			this.closeBinShipmentLog()
			this.shippingid = shippingid;
			this.removeShipmentConfirmationModel = true
    },
    continueRemoveShipment() {
      this.removeShipmentConfirmationModel = false
			this.removeBinShipment();
    },
		openUpdateStatusModal(data) {
      this.binid = '';
      this.UpdateStatusModal = true;
      this.binid = data.binid;
    },
    closeUpdateStatusModal() {
      this.UpdateStatusModal = false
    },
		deactivateBin() {
			this.isLoading = true;
      this.input = {
				currentHubId: this.hubId,
				lastModifiedBy: this.createdby,
        binid: this.binid
      }
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'deactivateOpenBin',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage)
            this.closeUpdateStatusModal();
            this.showHourlyHubBagCount();
          } else {
            this.$alertify.error(result.data.ReturnMessage)
          }
					this.isLoading = false;
        }, error => {
					this.isLoading = false;
          console.error(error)
        })
    },
	}
}



// WEBPACK FOOTER //
// ./src/views/components/ScanToBagActiveBinReport/ScanToBagActiveBinReport.js